function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m30.1 43.8c0 1.7-1 3-2.6 4.1 8.6 2.5 21.5.1 21.5-4.3v-2.9c-3.8 3.1-12 4.2-18.9 3.1z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m30.1 37c0 .6-.2 1.2-.4 1.7.3.6.4 1.2.4 1.9v1.1c6.9 1.2 15.2-.1 18-3 .6-.6.9-1.2.9-1.9 0-5.4 0-.7 0-2.9-.6.5-1.4 1-2.3 1.4-4.3 2-11.1 2.5-16.6 1.7z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m30.1 30.1c0 .6-.2 1.2-.4 1.7.3.5.4 1.1.4 1.7v.1 1.1c1.6.3 3.4.4 5.3.4 3.7 0 10.1-.8 12.7-3.4.6-.6.9-1.2.9-1.9 0-5.4 0-.6 0-3-.6.5-1.4 1-2.3 1.4-4.3 2.3-11.1 2.8-16.6 1.9z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m35.5 14.7c-1.9 0-3.7.1-5.3.4v1.1c0 .7-.1 1.3-.4 1.9.5 1.1.4 1.9.4 3.8 0 1.2.1 1.9-.4 3 .5 1 .4 1.9.4 3 6.6 1.1 15.2-.1 18-3 .6-.6.9-1.2.9-1.9 0-1.6 0-2.4 0-3.1-.1-2.8-6.1-5.2-13.6-5.2z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m28 40.7c-3.3 2.6-9.2 3.5-13.5 3.5-5.3 0-10.6-1.2-13.5-3.5v2.9c0 2.9 6.1 5.3 13.5 5.3 7.2 0 13.5-2.3 13.5-5.3 0-1 0-1.8 0-2.9z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m14.5 42.1c4.3 0 10.3-.9 12.7-3.4.6-.6.9-1.2.9-1.9 0-1.2 0 1.4 0-2.8v-.1c-5.4 4.5-21.1 4.8-27 0v2.8.2c0 .7.3 1.3.9 1.9 1.8 1.9 6.7 3.3 12.5 3.3z"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m1.9 31.8c4.4 4.6 21.1 4.4 25.3 0 .6-.6.9-1.2.9-1.9 0-1.3 0-1.6 0-2.8v-.1c-5.6 4.7-21.2 4.7-27 0v2.9c-.1.7.2 1.4.8 1.9z"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m1.9 25c4.3 4.4 20.8 4.6 25.3 0 .6-.6.9-1.2.9-1.9 0-1.4 0-1.7 0-2.8v-.1c-5.5 4.5-21.1 4.8-27.1 0 0 3.1-.2 3.7.9 4.8z"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m1.9 18.2c.9.9 2.4 1.7 4.4 2.3 7.1 2.2 17.6 1 20.9-2.3.6-.6.9-1.2.9-1.9 0-1.2 0 .2 0-2.9-5.8 4.6-21.3 4.6-27.1 0v2.8.2c0 .6.3 1.2.9 1.8z"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m27.2 11.3c1.1-1.1.9-1.6.9-5 0-2.9-6-5.3-13.5-5.3-7.5.1-13.6 2.4-13.6 5.3v3.2c0 .7.3 1.3.9 1.9 4.4 4.5 21 4.4 25.3-.1z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    enableBackground: "new 0 0 50 50",
    fill: "#474747",
    height: 100,
    viewBox: "0 0 50 50",
    width: 100
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};
export default __webpack_public_path__ + "static/media/money_icon_dark.b39d1dc9.svg";
export { SvgComponent as ReactComponent };